import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckFaturamentoPresumido = ({ check }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = check?.checkDetails
  const activity = details && typeof details === 'object' && !details.informação ? details : null;
  const hasResults = !!activity;

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('messages:kyb.checks.title.faturamentoPresumido')}</Typography>
        <CheckRiskStatus checkLength={hasResults ? 1 : 0} hasChecks={hasResults} />
      </Paper>

      <CheckDetailTitle
        email={check?.email}
        status={check?.status}
        createdAt={check?.createdAt}
        updatedAt={check?.updatedAt}
      />

      {activity && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:incomeRange')}</Typography>
                <Typography variant="subtitle3">{activity.IncomeRange ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:activityLevel')}</Typography>
                <Typography variant="subtitle3">{activity.ActivityLevel ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:shellCompanyLikelyhood')}</Typography>
                <Typography variant="subtitle3">{activity.ShellCompanyLikelyhood ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:employeesRange')}</Typography>
                <Typography variant="subtitle3">{activity.EmployeesRange ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:numberOfBranches')}</Typography>
                <Typography variant="subtitle3">{activity.NumberOfBranches ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:hasActiveDomain')}</Typography>
                <Typography variant="subtitle3">{activity.HasActiveDomain ? t('common:yes') : t('common:no')}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:hasActiveSSL')}</Typography>
                <Typography variant="subtitle3">{activity.HasActiveSSL ? t('common:yes') : t('common:no')}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:hasCorporateEmail')}</Typography>
                <Typography variant="subtitle3">{activity.HasCorporateEmail ? t('common:yes') : t('common:no')}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:hasRecentAddress')}</Typography>
                <Typography variant="subtitle3">{activity.HasRecentAddress ? t('common:yes') : t('common:no')}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:hasRecentPhone')}</Typography>
                <Typography variant="subtitle3">{activity.HasRecentPhone ? t('common:yes') : t('common:no')}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:hasRecentEmail')}</Typography>
                <Typography variant="subtitle3">{activity.HasRecentEmail ? t('common:yes') : t('common:no')}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:hasRecentPassages')}</Typography>
                <Typography variant="subtitle3">{activity.HasRecentPassages ? t('common:yes') : t('common:no')}</Typography>
              </div>
            </div>
          </Paper>
        </TimelineDotLine>
      )}


      {details?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ mt: 2 }}>
          <div className="c-detail-row">
            <Typography variant="subtitle1">{t('common:information')}</Typography>
            <Typography variant="subtitle3">{details.informação}</Typography>
          </div>
        </Paper>
      )}
    </>
  )
}

export default CheckFaturamentoPresumido
